// Skeleton Loader Component for Loading States
import { cn } from '@utils/classNames';

interface SkeletonLoaderProps {
  className?: string;
  variant?: 'text' | 'circular' | 'rectangular';
  width?: string | number;
  height?: string | number;
}

export const SkeletonLoader = ({ 
  className, 
  variant = 'rectangular',
  width,
  height 
}: SkeletonLoaderProps) => {
  const baseClasses = 'animate-pulse bg-white/10 rounded';
  
  const variantClasses = {
    text: 'h-4 rounded',
    circular: 'rounded-full',
    rectangular: 'rounded-lg',
  };

  const style: React.CSSProperties = {};
  if (width) style.width = typeof width === 'number' ? `${width}px` : width;
  if (height) style.height = typeof height === 'number' ? `${height}px` : height;

  return (
    <div
      className={cn(baseClasses, variantClasses[variant], className)}
      style={style}
    />
  );
};

// File List Skeleton
export const FileListSkeleton = ({ count = 5 }: { count?: number }) => {
  return (
    <div className="space-y-2">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex items-center gap-4 p-3 bg-white/5 rounded-lg">
          <SkeletonLoader variant="circular" width={40} height={40} />
          <div className="flex-1 space-y-2">
            <SkeletonLoader variant="text" width="60%" />
            <SkeletonLoader variant="text" width="40%" />
          </div>
          <SkeletonLoader variant="text" width={60} height={20} />
        </div>
      ))}
    </div>
  );
};

// Dashboard Stats Skeleton
export const StatsSkeleton = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="bg-white/5 rounded-lg p-4">
          <SkeletonLoader variant="text" width="40%" className="mb-2" />
          <SkeletonLoader variant="text" width="60%" height={24} />
        </div>
      ))}
    </div>
  );
};

